module.exports = __webpack_public_path__ + "static/media/14_digginglight.054115ac.jpg";